import React from "react";

import { Switch, Route } from "react-router-dom";

import { Container } from "@material-ui/core";

import useStyles from "./style";
import {
  Browse,
  Alamat,
  Products,
  ProdukDetail,
  UbahProfilToko,
  UbahProfilSeller,
  RewardPoint,
  UbahKataSandi,
  Pilih,
  PilihPromo,
  KomisiSaya,
  PencairanSaya,
  TransaksiList,
  Cart,
  Rekening,
  // RincianRekening,
  // TambahRekening,
  PusatBantuan,
  JaringanSaya,
  RewardList,
  Kategori,
  Pengaturan,
  Verifikasi,
  TokoramePoint,
  PointRiwayat,
  PointInfo,
  CheckIn,
  VoucherHistory,
  CollectionDetails,
  Donasi
} from "..";
import RekomendasiSaya from "../rekomendasiSaya";
import Checkout from "../cart/checkout";
import Moota from "../moota";

function LayoutB() {
  const classes = useStyles();
  return (
    <Container
      maxWidth="md"
      classes={{ root: classes.container }}
      className={classes.mainContainer}
    >
      <Switch>
        <Route path="/browse" component={Browse} />
        <Route exact path="/kategori" component={Kategori} />
        <Route exact path="/alamat" component={Alamat} />
        <Route path="/kategori/:id" component={Products} />
        <Route path="/tokosaya/pilih" component={Pilih} />
        <Route path="/tokosaya/promo" component={PilihPromo} />
        <Route path="/katalog/:id" component={Products} />
        <Route
          path="/produk/:nama/:id"
          render={(props) => <ProdukDetail key={props.match.params.id} />}
        />
        <Route
          path="/collections/:id"
          component={CollectionDetails}
        />
        <Route path="/akun/pengaturan" component={Pengaturan} />
        <Route path="/akun/ubahtoko" component={UbahProfilToko} />
        <Route path="/akun/ubahseller" component={UbahProfilSeller} />
        <Route path="/akun/rewardpoint" component={RewardPoint} />
        <Route path="/akun/rekening" component={Rekening} />
        {/* <Route path="/akun/tambah-rekening/" component={TambahRekening} /> */}
        {/* <Route
          path="/akun/ubah-rekening/:id/:length"
          component={RincianRekening}
        /> */}
        <Route path="/akun/ubahsandi" component={UbahKataSandi} />
        <Route path="/akun/bantuan" component={PusatBantuan} />
        <Route path="/akun/rewardlist" component={RewardList} />
        <Route path="/akun/verifikasi" component={Verifikasi} />
        <Route path="/transaksi/komisisaya" component={KomisiSaya} />
        <Route path="/transaksi/pencairansaya" component={PencairanSaya} />
        <Route
          path="/transaksi/transaksilist/:mode/:title"
          component={TransaksiList}
        />
        <Route path="/transaksi/jaringansaya" component={JaringanSaya} />
        <Route path="/transaksi/rekomendasisaya" component={RekomendasiSaya} />
        <Route path="/moota/:token" component={Moota} />
        <Route path="/cart" component={Cart} />
        <Route path="/checkout" component={Checkout} />
        <Route exact path="/tokoramecoin" component={TokoramePoint} />
        <Route path="/tokoramecoin/riwayat" component={PointRiwayat} />
        <Route path="/tokoramecoin/info" component={PointInfo} />
        <Route path="/tokoramecoin/daily-checkin" component={CheckIn} />
        <Route
          path="/tokoramecoin/voucher-history"
          component={VoucherHistory}
        />
        <Route
          path="/donasi/:id/:idReference"
          component={Donasi}
        />
      </Switch>
    </Container>
  );
}

export default LayoutB;
